export default __webpack_public_path__ + "static/media/link-external.cff5e772.svg";